export const regEx = /^dp\..+\.team$/;
